module.exports = __webpack_public_path__ + "static/img/demo-card-fox.6f58ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo-card-fox.png
// module id = 4f8M
// module chunks = 1